// extracted by mini-css-extract-plugin
module.exports = {"sort":"sorting-indicator_sort__1aviz","icon":"sorting-indicator_icon__3W9BT"};